import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export type CardItemPromoTheme = 'lightBlue' | 'blue' | 'green' | 'yellow';

export interface CardItemPromoData {
  theme: CardItemPromoTheme;
  title: string;
  link?: LocationDescriptor;
  onClick?: MouseEventHandler;
}

export interface CardItemPromoProps extends CardItemPromoData {}
